
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from "@firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDgjEfwBQ4Oz5AiAKFps29nzZIGg2jW1Rk",
  authDomain: "studio-chrysalis.firebaseapp.com",
  databaseURL: "https://studio-chrysalis-default-rtdb.firebaseio.com",
  projectId: "studio-chrysalis",
  storageBucket: "studio-chrysalis.appspot.com",
  messagingSenderId: "29344611869",
  appId: "1:29344611869:web:3c7a4f46412722d69bd0f4",
  measurementId: "G-P09CYW3DVK"
  // apiKey: process.env.REACT_APP_API_KEY,
  // authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  // databaseURL: process.env.REACT_APP_DATABASE_URL,
  // projectId: process.env.REACT_APP_PROJECT_ID,
  // storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  // messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  // appId: process.env.REACT_APP_APP_ID,
  // measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);